import { FC } from 'react';

import { Board, Council } from 'types';
import { useTranslate } from 'hooks/useTranslate';
import { getBoardStatusData } from 'utils/getBoardStatusData';
import { getCardItems } from '../../BoardDetailsInfoCard/utils/getCardItems';

type BoardDetailsInfoCardBodyProps = {
  board: Board | Council | undefined;
};

const BoardDetailsInfoCardBody: FC<BoardDetailsInfoCardBodyProps> = ({
  board,
}) => {
  const { t } = useTranslate();

  const status = getBoardStatusData(board, (board as Board).entityType);

  const items = getCardItems({ board, status });

  return (
    <div className="card rounded-xl">
      <ul className="data-list is-compact">
        {items?.map(({ title, value, valueNeedsTranslation }) => (
          <li className="data-item" key={title}>
            <div className="data-col">
              <div className="data-label align-self-start">{t(title)}</div>
              <div className="data-value">
                {valueNeedsTranslation ? t(value) : value}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BoardDetailsInfoCardBody;
